export function initVideoPlayHandler() {
    
    // Add event listener to all play buttons
    document.querySelectorAll(".js-playvideo").forEach((playBtn) => {
        playBtn.addEventListener("click", function (e) {
            e.preventDefault();

            // Stop all previously playing videos and remove 'hide' from play buttons and header content
            document.querySelectorAll("video").forEach((video) => {
                if (!video.paused) video.pause();
            });
            document
                .querySelectorAll(".js-playvideo.hide")
                .forEach((btn) => btn.classList.remove("hide"));
            document
                .querySelectorAll(".header-content-box.hide")
                .forEach((box) => box.classList.remove("hide"));
            document
                .querySelectorAll(".js-pause-button")
                .forEach((btn) => btn.classList.add("hide"));

            // Find the header content element to hide
            const headerContent =
                this.querySelector(".header-content-box") ||
                this.closest(".header-content-box") ||
                this.parentElement.querySelector(".header-content-box");

            // Traverse up to find the media container
            let mediaContainer = this;
            while (
                mediaContainer &&
                !mediaContainer.classList.contains("media-type-video")
            ) {
                mediaContainer = mediaContainer.parentElement;
            }

            if (!mediaContainer) {
                console.warn(
                    'Media container with class "media-type-video" not found'
                );
                return;
            }

            // Find video element within the media container
            // Look for video in both desktop and mobile containers, play the one that's not hidden
            let video = null;
            const desktopContainer = mediaContainer.querySelector(
                ".video-container.desktop"
            );
            const mobileContainer = mediaContainer.querySelector(
                ".video-container.mobile"
            );

            if (
                desktopContainer &&
                getComputedStyle(desktopContainer).display !== "none"
            ) {
                video = desktopContainer.querySelector("video");
            } else if (
                mobileContainer &&
                getComputedStyle(mobileContainer).display !== "none"
            ) {
                video = mobileContainer.querySelector("video");
            } else {
                // Fallback: try to find any visible video
                const allVideos = mediaContainer.querySelectorAll("video");
                for (let v of allVideos) {
                    const container = v.closest(".video-container");
                    if (
                        !container ||
                        getComputedStyle(container).display !== "none"
                    ) {
                        video = v;
                        break;
                    }
                }
            }

            if (!video) {
                console.warn("Video element not found within media container");
                return;
            }

            // Hide header content smoothly if it exists
            if (headerContent) {
                headerContent.classList.add("hide");
            }

            // Show pause button within the media container
            const pauseButton =
                mediaContainer.querySelector(".js-pause-button");
            if (pauseButton) {
                pauseButton.classList.remove("hide");
            }

            // Play the video
            video.play().catch((err) => {
                console.error("Error playing video:", err);
            });

            // Optional: Hide the play button itself
            this.classList.add("hide");
        });
    });

    // Add event listener to all pause buttons
    document.querySelectorAll(".js-pause-button").forEach((pauseBtn) => {
        pauseBtn.addEventListener("click", function (e) {
            e.preventDefault();

            // Traverse up to find the media container
            let mediaContainer = this;
            while (
                mediaContainer &&
                !mediaContainer.classList.contains("media-type-video")
            ) {
                mediaContainer = mediaContainer.parentElement;
            }

            if (!mediaContainer) {
                console.warn(
                    'Media container with class "media-type-video" not found'
                );
                return;
            }

            // Find video element within the media container
            // Look for video in both desktop and mobile containers, pause the one that's playing
            let video = null;
            const desktopContainer = mediaContainer.querySelector(
                ".video-container.desktop"
            );
            const mobileContainer = mediaContainer.querySelector(
                ".video-container.mobile"
            );

            if (
                desktopContainer &&
                getComputedStyle(desktopContainer).display !== "none"
            ) {
                const desktopVideo = desktopContainer.querySelector("video");
                if (desktopVideo && !desktopVideo.paused) {
                    video = desktopVideo;
                }
            }

            if (
                !video &&
                mobileContainer &&
                getComputedStyle(mobileContainer).display !== "none"
            ) {
                const mobileVideo = mobileContainer.querySelector("video");
                if (mobileVideo && !mobileVideo.paused) {
                    video = mobileVideo;
                }
            }

            if (!video) {
                // Fallback: find any playing video
                const allVideos = mediaContainer.querySelectorAll("video");
                for (let v of allVideos) {
                    if (!v.paused) {
                        video = v;
                        break;
                    }
                }
            }

            if (!video) {
                console.warn("Video element not found within media container");
                return;
            }

            // Pause the video
            video.pause();

            // Show header content box
            const headerContent = mediaContainer.querySelector(
                ".header-content-box"
            );
            if (headerContent) {
                headerContent.classList.remove("hide");
            }

            // Hide the pause button itself
            this.classList.add("hide");

            // Show play button again
            const playButton = mediaContainer.querySelector(".js-playvideo");
            if (playButton) {
                playButton.classList.remove("hide");
            }
        });
    });
}
